import { Model } from "./Types.fs.js";
import { Cmd_none } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";

export function init(page, user, lastModel) {
    return [new Model(page), Cmd_none()];
}

export function update(msg, model) {
    return [new Model(msg.fields[0]), Cmd_none()];
}

//# sourceMappingURL=State.fs.js.map
